import React from 'react'
import {
  Container,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Typography,
  Toolbar,
} from '@mui/material'
import AssetModal from './AssetModal'
import type {Asset} from '@prisma/client'
import {useTheme} from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

interface AssetSheetProps {
  namespace?: string
  assets: Array<Asset>
}

const AssetSheet: React.FC<AssetSheetProps> = props => {
  const {namespace, assets} = props
  const [selectedAsset, setSelectedAsset] = React.useState<any>(null)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Container sx={{my: 4}}>
      <Toolbar />
      <Typography variant="h3" component="h1" mb={2} sx={{marginLeft: '32px'}}>
        Assets for {namespace}
      </Typography>
      {assets && assets.length > 0 ? (
        <>
          <Typography
            sx={{
              fontFamily: 'Monospace',
              backgroundColor: '#eee',
              width: 'fit-content',
              padding: '2px 4px',
              marginLeft: '30px',
            }}
          >
            npm i -s https://static.basedcdn.com/{namespace}/src/dist.zip
          </Typography>
          <ImageList variant="masonry" cols={isMobile ? 1 : 4} gap={8}>
            {assets.map(a => (
              <ImageListItem
                tabIndex={0}
                key={a.id}
                onClick={e => setSelectedAsset(a)}
                sx={{
                  margin: '16px',
                  padding: '16px',
                  '&:hover': {
                    cursor: 'pointer',
                    boxShadow: 3,
                  },
                }}
              >
                {a.based_uri && (
                  <img src={a.based_uri} alt={a.filename || `Asset ${a.id}`} loading="lazy" />
                )}
                <ImageListItemBar
                  title={a.filename}
                  position="below"
                  sx={{alignContent: 'center'}}
                />
              </ImageListItem>
            ))}
            {selectedAsset && <AssetModal {...selectedAsset} setSelectedAsset={setSelectedAsset} />}
          </ImageList>
        </>
      ) : (
        <Typography variant="body1">No assets in the namespace.</Typography>
      )}
    </Container>
  )
}

export default AssetSheet
